import { render, staticRenderFns } from "./DialogProfileSignature.vue?vue&type=template&id=64d1b016&scoped=true"
import script from "./DialogProfileSignature.vue?vue&type=script&lang=js"
export * from "./DialogProfileSignature.vue?vue&type=script&lang=js"
import style0 from "./DialogProfileSignature.vue?vue&type=style&index=0&id=64d1b016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d1b016",
  null
  
)

export default component.exports